import React, { useEffect, useState } from "react";
import { RecipesViewModel } from "../../../../viewmodels/recipes/RecipesViewModel";
import { ProductRndViewModel } from "../../../../viewmodels/setup/productRnD/ProductRndViewModel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import SelectMenu from "../../../../components/controls/SelectMenu";
import EquipmentViewModel from "../../../../viewmodels/setup/equipmentViewModel/EquipmentViewModel";

export default function ProductRnd(props: any) {
  const { product, logout, addSnackbar } = props;

  const { fetchRecipeByPlu, fetchedRecipe } = RecipesViewModel(logout) as any;

  const {
    equipments,
    createEquipment,
    getEquipments,
    deleteEquipment,
    removeEquipment,
    addEquipment,
    equipmentForm,
    onChangeEquipmentField,
    fetchEquipmentsForDropdown,
    equipmentOptions,
    assignEquipmentToProduct,
    unassignEquipmentFromProduct,
    fetchAssignedEquipmentToProduct,
    assignedEquipments,
    handleEquipmentChange,
  } = EquipmentViewModel(logout, product?.id || 0, addSnackbar) as any;

  const { productRnds, getProductRnds, updateProductRnd, setProductRnds } =
    ProductRndViewModel(logout, addSnackbar, product.id) as any;

  useEffect(() => {
    fetchRecipeByPlu(product?.plu);
    getEquipments(product?.id);
    getProductRnds(product?.id);
    fetchEquipmentsForDropdown();
    fetchAssignedEquipmentToProduct(product?.id);
  }, [product]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="p-6">
          <div className="w-full">
            <div className="bg-white">
              {!fetchedRecipe.recipe ? (
                <div className="p-4 text-sm text-gray-500">
                  No recipe found for this product.
                </div>
              ) : (
                <div>
                  <div className="px-4 py-3 border-b">
                    <h3 className="text-lg font-medium">
                      {fetchedRecipe.recipe?.recipe_name}
                    </h3>
                    <p className="text-sm text-gray-500">
                      PLU: {fetchedRecipe.recipe?.recipe_number}
                    </p>
                  </div>

                  <div className="p-4">
                    <h4 className="text-md font-semibold mb-2">Ingredients</h4>
                    <div className="overflow-hidden card-custom bg-white">
                      <DataTable
                        value={fetchedRecipe.recipeItems}
                        tableClassName="min-w-full text-sm bg-white divide-y divide-gray-300"
                      >
                        <Column field="bom_plu" header="BOM PLU" />
                        <Column field="bom_name" header="Name" />
                        <Column
                          field="quantity"
                          header="Required"
                          body={(row) =>
                            `${row.quantity} ${row.unit_of_measure_label || ""}`
                          }
                        />
                        <Column field="recipe_per_kg" header="Per Kg" />
                      </DataTable>
                    </div>
                  </div>
                </div>
              )}
              <div className="px-4 py-3 border-b">
                <h4 className="text-md font-semibold mb-2">
                  Product Equipment
                </h4>
                <SelectMenu
                  isMulti={true}
                  handleInputChange={(e: any) => {
                    handleEquipmentChange(e.target.value);
                  }}
                  options={equipmentOptions}
                  value={assignedEquipments}
                />
              </div>
              <div className="px-4 py-3">
                <div className="mt-4">
                  <div className="px-4 py-3 border-b">
                    <h4 className="text-md font-semibold mb-2">Procedure</h4>
                  </div>
                  <div className="grid grid-cols-5 gap-4">
                    <div className="col-span-5">
                      <InputTextarea
                        autoResize
                        value={productRnds.notes}
                        onChange={(e: any) =>
                          setProductRnds({
                            ...productRnds,
                            notes: e.target.value,
                          })
                        }
                        rows={5}
                        cols={30}
                        className="w-full"
                      />
                      <div className="flex justify-end mt-2">
                        <Button
                          label="Save"
                          onClick={updateProductRnd}
                          className="px-4 py-2 text-sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
